module.exports = "<button mat-raised-button id=\"googleBtn\">Login with <img src=\"../../../../assets/icons/google.png\"> Google</button>"